import { useCallback, useEffect } from "react"
import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useRoleCookie from "shared/model/useRoleCookie"
import { ROLE_STORE_MANAGER, ROLE_EXTERNAL_ADMIN, ROLE_FRANCHISE_MANAGER } from "shared/constant/lookup/role"

const useGetStoreTicketTypes = () => {
    const [fetchResult, fetchRequest, isLoading] = useFetch()
    const [, setAlert] = useAlertModalAtom()
    const [roleCookie] = useRoleCookie()

    const refetch = useCallback(() => {
        if (roleCookie === ROLE_EXTERNAL_ADMIN) {
            fetchRequest("GET", "/external-admin/store/ticket-types")
        } else if (roleCookie === ROLE_STORE_MANAGER || roleCookie === ROLE_FRANCHISE_MANAGER) {
            fetchRequest("GET", "/admin/store/ticket-types")
        }
    }, [roleCookie])

    useEffect(() => {
        refetch()
    }, [refetch])

    useEffect(() => {
        if (fetchResult) {
            switch (fetchResult?.statusCode) {
                case 400:
                    setAlert("데이터를 불러오는데 실패했습니다.")
                    break
                case 401:
                case 403:
                    setAlert("현재 권한으로 접근할 수 없습니다.")
                    break
            }
        }
    }, [fetchResult])

    

    if (roleCookie !== ROLE_STORE_MANAGER && roleCookie !== ROLE_EXTERNAL_ADMIN && roleCookie !== ROLE_FRANCHISE_MANAGER) {
        return [
            { data: { ticket_types: [] } },
            false, 
            () => {}
        ]
    }

    return [fetchResult, isLoading, refetch]
}

export default useGetStoreTicketTypes